// /opt/ptg01-v1/front-admin/components/PageHeader.tsx
// Bandeau au-dessus des colonnes 2 et 3 : titre + sous-titre + actions, puis grille de compteurs — CONVENTIONS.md § 6.
import React from 'react';

export default function PageHeader({ icon, title, subtitle, actions, kpis, cols = 4, children }: {
    icon?: React.ReactNode;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    kpis?: React.ReactNode;
    cols?: number;
    children?: React.ReactNode;
}) {
    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between gap-4">
                <div className="min-w-0">
                    <h1 className="text-[16px] font-bold text-black flex items-center gap-2">{icon}{title}</h1>
                    {subtitle && <p className="text-[11px] text-black/75 mt-0.5 truncate">{subtitle}</p>}
                </div>
                {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
            </div>
            {kpis && <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>{kpis}</div>}
            {children}
        </div>
    );
}
